// extracted by mini-css-extract-plugin
module.exports = {"v10reqfk":"v10reqfk","loading-animation-bar":"loading-animation-bar"};